import * as Bixby from '$/core';
import { API_ACTION_ACCOUNT_COMPANY, API_ACTION_ACCOUNT_SECTOR } from '$/core/constants';

export abstract class AccountService {
  private static baseUrl = `${Bixby.Constants.API_ACCOUNTCONTROLLER}`;
  public static async getCompanies(): Promise<Bixby.Models.AccountUserCompany[]> {
    const route = Bixby.API.ServerRoute.forAction(`${AccountService.baseUrl}/${API_ACTION_ACCOUNT_COMPANY}`);
    const results: Bixby.Models.AccountUserCompany[] = await Bixby.API.get(route);
    return results;
  }

  public static async getSectors(): Promise<Bixby.Models.AccountUserIndustryRollup[]> {
    const route = Bixby.API.ServerRoute.forAction(`${AccountService.baseUrl}/${API_ACTION_ACCOUNT_SECTOR}`);
    const results: Bixby.Models.AccountUserSector[] = await Bixby.API.get(route);

    return AccountService.rollUpIndustries(results);
  }

  // My Industries
  public static async updateAccountUserSectorAlertState(
    id: string,
    alertsEnabled: boolean
  ): Promise<Bixby.Models.AccountUserIndustryRollup[]> {
    const route = Bixby.API.ServerRoute.forAction(
      `${AccountService.baseUrl}/${Bixby.Constants.API_ACTION_ACCOUNT_SECTOR}/${id}/${Bixby.Constants.API_ACTION_ACCOUNT_SECTOR_ALERTS}/${alertsEnabled}`
    );
    const results: Bixby.Models.AccountUserSector[] = await Bixby.API.put(route, null);
    return AccountService.rollUpIndustries(results);
  }

  public static async updateAccountUserIndustryGroupAlertState(
    id: string,
    alertsEnabled: boolean
  ): Promise<Bixby.Models.AccountUserIndustryRollup[]> {
    const route = Bixby.API.ServerRoute.forAction(
      `${AccountService.baseUrl}/${Bixby.Constants.API_ACTION_ACCOUNT_INDUSTRYGROUP}/${id}/${Bixby.Constants.API_ACTION_ACCOUNT_INDUSTRYGROUP_ALERTS}/${alertsEnabled}`
    );
    const results: Bixby.Models.AccountUserSector[] = await Bixby.API.put(route, null);
    return AccountService.rollUpIndustries(results);
  }

  public static async updateAccountUserSectorMyPortfolioState(
    id: string,
    myPortfolio: boolean
  ): Promise<Bixby.Models.AccountUserIndustryRollup[]> {
    const route = Bixby.API.ServerRoute.forAction(
      `${AccountService.baseUrl}/${Bixby.Constants.API_ACTION_ACCOUNT_SECTOR}/${id}/${Bixby.Constants.API_ACTION_ACCOUNT_SECTOR_MYPORTFOLIO}/${myPortfolio}`
    );
    const results: Bixby.Models.AccountUserSector[] = await Bixby.API.put(route, null);
    return AccountService.rollUpIndustries(results);
  }

  public static async updateAccountUserIndustryGroupMyPortfolioState(
    id: string,
    myPortfolio: boolean
  ): Promise<Bixby.Models.AccountUserIndustryRollup[]> {
    const route = Bixby.API.ServerRoute.forAction(
      `${AccountService.baseUrl}/${Bixby.Constants.API_ACTION_ACCOUNT_INDUSTRYGROUP}/${id}/${Bixby.Constants.API_ACTION_ACCOUNT_INDUSTRYGROUP_MYPORTFOLIO}/${myPortfolio}`
    );
    const results: Bixby.Models.AccountUserSector[] = await Bixby.API.put(route, null);
    return AccountService.rollUpIndustries(results);
  }

  // My Companies
  public static async updateAccountUserCompanyAlertState(
    id: string,
    alertsEnabled: boolean
  ): Promise<Bixby.Models.AccountUserCompany[]> {
    const route = Bixby.API.ServerRoute.forAction(
      `${AccountService.baseUrl}/${Bixby.Constants.API_ACTION_ACCOUNT_COMPANY}/${id}/${Bixby.Constants.API_ACTION_ACCOUNT_COMPANY_ALERTS}/${alertsEnabled}`
    );
    return await Bixby.API.put(route, null);
  }

  public static async updateAccountUserCompanyMyPortfolioState(
    id: string,
    myPortfolio: boolean
  ): Promise<Bixby.Models.AccountUserCompany[]> {
    const route = Bixby.API.ServerRoute.forAction(
      `${AccountService.baseUrl}/${Bixby.Constants.API_ACTION_ACCOUNT_COMPANY}/${id}/${Bixby.Constants.API_ACTION_ACCOUNT_COMPANY_MYPORTFOLIO}/${myPortfolio}`
    );
    return await Bixby.API.put(route, null);
  }

  public static async updateAccountAllUserCompaniesAlertState(alertsEnabled: boolean, isPublic: boolean) {
    const isPublicAction = isPublic ? Bixby.Constants.API_ACTION_PUBLIC : Bixby.Constants.API_ACTION_PRIVATE;
    const route = Bixby.API.ServerRoute.forAction(
      `${AccountService.baseUrl}/${Bixby.Constants.API_ACTION_ACCOUNT_COMPANY}/${isPublicAction}/${Bixby.Constants.API_ACTION_ACCOUNT_COMPANY_ALERTS}/${alertsEnabled}`
    );
    return await Bixby.API.put(route, null);
  }

  private static rollUpIndustries(results: Bixby.Models.AccountUserSector[]) {
    const rollup: Bixby.Models.AccountUserIndustryRollup[] = [];
    for (let s = 0; s < results.length; s++) {
      const sector: Bixby.Models.AccountUserSector = results[s];
      rollup.push({
        alertsEnabled: sector.alertsEnabled,
        id: sector.sector_Id,
        name: [sector.sector_Name],
        myPortfolioEnabled: sector.myPortfolioEnabled,
        type: 'Sector',
        sector_Id: sector.sector_Id,
        industryGroup_Id: null,
      });

      for (let ig = 0; ig < (sector.industryGroups || []).length; ig++) {
        const industryGroup: Bixby.Models.AccountUserIndustryGroup = sector.industryGroups[ig];
        rollup.push({
          alertsEnabled: industryGroup.alertsEnabled,
          id: industryGroup.industryGroup_Id,
          name: [sector.sector_Name, industryGroup.industryGroup_Name],
          myPortfolioEnabled: industryGroup.myPortfolioEnabled,
          type: 'IndustryGroup',
          sector_Id: sector.sector_Id,
          industryGroup_Id: industryGroup.industryGroup_Id,
        });
      }
    }

    return rollup;
  }
}
